<template>
    <div class="page page--gradient-background">
        <section class="aml">
            <loader v-if="isLoading" />
            <aml-questionnaire v-else
                refreshUserDetails
                :cancelRoute="routeToHome"
                :redirecTo="routeToHome"
            />
        </section>
    </div>
</template>

<script>

// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import amlQuestionnaire from '@webapp/modules/customer-first/components/aml-questionnaire/aml-questionnaire.vue';
import loader from '@webapp/components/loading-spinner/loading-spinner.vue';

export default {
    name: 'page-aml-questionnaire',
    components: {
        amlQuestionnaire,
        loader,
    },
    beforeRouteEnter(_to, _from, next) {
        next((vm) => {
            if (!vm.shouldFillAmlQuestionnaire) {
                vm.$router.push('/home/overview');

                return;
            }

            vm.isLoading = false;
        });
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters(['shouldFillAmlQuestionnaire']),

        routeToHome() {
            return {
                path: '/home/overview',
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.aml {
    padding: 6.5rem 2rem;
}
</style>